export default __webpack_public_path__ + "static/noise-234da8eebea5d4eb60934bba095af860.webp";